<div style="height: 40px; background-color: rgb(62, 203, 244); color: white; line-height: 40px; text-align: center; font-size: 20px">
  {{ asiakkaanTiedotObservable | async }}
</div>

<div #mainDiv>
  <div app-kirjanpito-tosite-naytto [piilotaYlaControllit]="true" [naytettavatTositteetJaSivut]="naytettavatTositteetJaSivutObservable | async" [scrollContainerRef]="mainDivRef" [naytettavaKirjausObservable]="naytettavaKirjausObservable"></div>
</div>
